"use client";

import { I18nUtil } from "@utils/i18n";
import React from "react";
import Translations from "@translate/components/Chat/TokenPopover/ActionButtons";
import { cn } from "utils";
import { usePathname } from "@hooks/usePathname";
const I18n = I18nUtil.createScoped(Translations);

interface ActionButtonsProps {
  symbol: string;
  showReport?: boolean; // 控制是否显示View Report按钮
  onForecastClick?: () => void;
  onReportClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isHKStock: boolean;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  symbol,
  showReport = true,
  onForecastClick,
  onReportClick,
  isHKStock,
}) => {
  const pathName = usePathname();
  const isSharePath = pathName.includes("share");

  return (
    <div className={cn("flex items-start gap-2 max-md:gap-3 w-full")}>
      <button
        aria-label="Action Buttons"
        data-openreplay-label={`Action Buttons Button | ${
          !isHKStock
            ? I18n.t("%{var0} Forecast", {
                var0: symbol,
              })
            : I18n.t("View Detail")
        }`}
        id="btn-action-buttons"
        className={cn(
          "button sm_button max-md:md_button tonal_button max-md:border max-md:border-border_white_transparent20 max-md:bg-background_solid_secondary",
          "body_m text-content_primary",
          showReport ? "flex-1" : "w-full",
        )}
        onClick={onForecastClick}
      >
        {!isHKStock
          ? I18n.t("%{var0} Forecast", {
              var0: symbol,
            })
          : I18n.t("View Detail")}
      </button>
      {showReport && !isSharePath && (
        <button
          aria-label="Action Buttons"
          data-openreplay-label="Action Buttons Button"
          id="btn-action-buttons-2"
          className={cn(
            "button sm_button max-md:md_button bg-content_primary flex-1",
            "inline-flex items-center justify-center gap-1",
            "button_m",
            "hover:bg-content_primary/80",
          )}
          onClick={onReportClick}
        >
          <span className="button_m font-bold text-content_inverse_primary">
            {I18n.t("View Report")}
          </span>
        </button>
      )}
    </div>
  );
};
